


import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyBRsHCkfHTDhwpSWSi5ZmAlKTY1D9VUZF8",
  authDomain: "gaxmore-it.firebaseapp.com",
  projectId: "gaxmore-it",
  storageBucket: "gaxmore-it.firebasestorage.app",
  messagingSenderId: "561807956907",
  appId: "1:561807956907:web:05603600758113dbf5d0ee"
};



const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export